import { useStore } from '@contexts/store'
import { userWithoutToken } from '@helper/userWithoutToken'
import { singleCurrencyObj } from '@interfaces/currencies'
import { useEffect, useState } from 'react'

export const useCurrencySwitcher = () => {
  const {
    storeData: storeBaseData,
    activeCurrency,
    setDefaultCurrency,
    analytics,
    user,
  } = useStore()

  const [selectedCurrency, setSelectedCurrency] =
    useState<singleCurrencyObj | null>(null)

  useEffect(() => {
    if (activeCurrency) {
      const fullCurrency = storeBaseData?.currencies?.find(
        (currency: any) => currency.currency._id === activeCurrency._id,
      )
      if (fullCurrency) {
        setSelectedCurrency(fullCurrency)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeBaseData, activeCurrency])

  function handleItemClick(values: any) {
    const currency = storeBaseData?.currencies?.find(
      (currency: any) => currency.currency._id === values,
    )
    if (currency) {
      setSelectedCurrency(currency)
      setDefaultCurrency(currency)
      analytics.track('Currency changed', {
        user: userWithoutToken(user),
        selectedCurrency: currency,
      })
    }
  }

  return {
    selectedCurrency,
    handleItemClick,
  }
}
